import React, {useEffect} from 'react';

import Content from './Content';
import {appConfig} from "../../config";
import {useTranslation} from "react-i18next";

const Index = () => {
    const {t} = useTranslation();

    useEffect(() => {
        document.title = `${appConfig.appName} - ${t('t-contact-us-head')}`;
    }, []);

    window.onscroll = function () {
        scrollFunction();
    };

    const scrollFunction = () => {
        const element = document.getElementById("back-to-top");
        if (element) {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                element.style.display = "block";
            } else {
                element.style.display = "none";
            }
        }
    };

    const toTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    return (
        <div className="layout-wrapper landing">
            <Content/>
            <button onClick={() => toTop()} className="btn btn-danger btn-icon landing-back-top" id="back-to-top">
                <i className="ri-arrow-up-line"></i>
            </button>
        </div>
    );
};

export default Index;